import AdditionalFields from 'Components/Client/Cases/CaseDetails/AdditionalFields';
import AdditionalInfoEdit from 'Components/Client/Cases/CaseDetails/AdditionalInfoEdit';
import DocumentsSection from 'Components/Client/Cases/CaseDetails/DocumentsSection';
import RequiredInfo from 'Components/Client/Cases/CaseDetails/RequiredInfo';
import StepperContent from 'Components/Client/Cases/CaseDetails/StepperContent';
import InfoIcon from 'Components/Icons/InfoIcon';
import { closeCaseApi, deleteCaseApi, getCaseDetApi } from 'Constants';
import { Context } from 'Context/Context';
import AreYouSureModal from 'Modals/AreYouSureModal';
import Stepper from 'Stepper/Stepper';
import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { IoIosArrowDropdownCircle, IoIosArrowDropupCircle} from "react-icons/io";
import ClientDetails from 'Components/Profile/ClientDetails';
import CaseProfDetails from './CaseProfDetails';
import { RxCross1 } from "react-icons/rx";
import moment from 'moment';


function AdminCompleteCaseDetails({id, onClose}) {
    
    
    const [caseDetails, setCaseDetails] = useState(null);
    const {userDetails, makeApiCallFunc} = useContext(Context);
    const [additionalFields, setAdditionalFields] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [contentStep, setContentStep] = useState(0);
    const navigate = useNavigate();
    const [isCaseOpen, setIsCaseOpen] = useState(true);
    const [noOfInterests, setNoOfInterests] = useState(0);
    const [updateComp, setUpdateComp] = useState(false);
    const [showClientDetails, setShowClientDetails] = useState(false);
    const [reportedData, setReportedData] = useState(false);
    const [showTabsContent, setShowTabsContent] = useState(1);



    const deleteCase = () => {
        makeApiCallFunc(
         deleteCaseApi,
         { id: id },
         ({data})=>
         {
             setShowModal(false);
             navigate("/client/cases");
             console.log(data)
         },
         function (error) {
             console.log(error)
         }
        )
     }
     const onCloseCase = () => {
       const  userId =  caseDetails?.userCase?.reqToClose?.[0]?.userId?._id;
       console.log(caseDetails?.userCase)
        const postData = {
            caseId: id,
            "userId" : userId
        }
        makeApiCallFunc(
            closeCaseApi,
            postData,
            (data) => {
                console.log(data);
                setUpdateComp(prev => !prev)
            },
            (data) => {
                console.log(data)
            }
        )
        
    }

    const aggregateList = (data) => {
        let noOfInterest = 0;
        let modifiedResponse = {
            "requested":[],
            "denied":[],
            "approved":[],
            "noConflict":[],
            "conflict":[],
            "reqToClose":[],
            "closed":[] 
        };
        data.map((entry) => {
          
          noOfInterest = noOfInterest + (entry?.deniedCount? entry?.deniedCount : 1);
          return modifiedResponse[entry.caseStatus]?.push(entry)
        });
        setCurrentStep(getStatusOfCase(modifiedResponse));
        setContentStep(getStatusOfCase(modifiedResponse));
        setNoOfInterests(noOfInterest);
        return modifiedResponse;
    }
    const getStatusOfCase = (data) => {
        let status = 1;
        if(data["closed"].length !== 0)
        {
            setIsCaseOpen(false);
            return 6;

        }
        if(data["reqToClose"].length !== 0)
        {
            return 5;
        }
        if(data["noConflict"].length !== 0)
        {
            return 4;
        }
        if(data["approved"].length !== 0)
        {
            return 3;
        }
        if(data["requested"].length !== 0)
        {
            return 2;
        }
        return status;
    }
    useEffect(() => {
        makeApiCallFunc(getCaseDetApi+"/"+id,
        null,
        ({data}) => {
            setCaseDetails({...data?.case, "userCase" : aggregateList(data.users)});
            setReportedData(getReportData(data));
            setAdditionalFields(data?.case?.additionalFields ? JSON.parse(data?.case?.additionalFields) : null)
                   }
            ,
        (data) => console.log(data)
        )
    },[updateComp])
    const getReportData = (data) => {
        let reportData = []
        data?.users.map((da) => {
           if(da.reported.count === 1)
           {
                reportData.push(da);
           }
        })
        return reportData;
    }
  return (
    <>
    {
        showModal &&
        <AreYouSureModal
        uploadNew= {showModal}
         onClose={()=> setShowModal(false)}
         onSubmit = {deleteCase}
        />  
    }
    {
        caseDetails ?
        <div className='w-full h-full text-xs'>
            <div className='bg-sky-50 w-full  pb-10'>
                {/* <div className='text-md flex  items-center w-full justify-center p-4'>
                    <div className= {(caseDetails.is_deleted ? "bg-gray-100 text-gray-600 ring-1 ring-gray-600 ring-offset-2" :contentStep === 6 ? 'bg-red-100 text-red-600 ring-1 ring-red-600 ring-offset-2' : (contentStep === 5 ? 'bg-yellow-100 text-yellow-600 ring-1 ring-yellow-600 ring-offset-2' : 'bg-green-100 text-green-600 ring-1 ring-green-600 ring-offset-2')) + ' p-2 rounded mt-10'}>
                    The Case is {caseDetails.is_deleted ? "Deleted" : contentStep === 5 ? "Pending Closing" : ( contentStep === 6 ? "Closed" : "Open")}
                    </div>
                </div> */}
                <div className='w-full rounded lg:p-6 p-2 flex flex-col  justify-between'>
                    <div className='flex w-full justify-end cursor-pointer' onClick={onClose}>
                    <RxCross1 />

                    </div>
                   <div className='flex w-full lg:text-md text-xs'>
                        <div className={(showTabsContent === 1 ? 'bg-white border-t-sky-600 border-l-sky-600 border-r-sky-600 text-sky-600 border-b-0 ' : 'border-t-0 border-l-0 border-r-0 border-b-sky-600') + ' p-2 border font-bold text-xs w-full  text-gray-800 flex items-center justify-between cursor-pointer'} onClick={()=>setShowTabsContent(1)}>Case details</div>
                        {additionalFields && <div className={(showTabsContent === 2 ? 'bg-white border-t-sky-600 border-l-sky-600 border-r-sky-600 text-sky-600 border-b-0 ' : 'border-t-0 border-l-0 border-r-0 border-b-sky-600') + ' p-2 border font-bold text-xs w-full  text-gray-800 flex items-center justify-between cursor-pointer'} onClick={()=>setShowTabsContent(2)}>Additional case details</div>
                        }
                        {((caseDetails?.["supportingDocuments"] && caseDetails?.["supportingDocuments"]?.length !== 0) || (caseDetails?.["videoDocuments"] && caseDetails?.["videoDocuments"]?.length !==0)) &&
                        <div className={(showTabsContent === 6? 'bg-white border-t-sky-600 border-l-sky-600 border-r-sky-600 text-sky-600  border-b-0 ' : ' border-t-0 border-l-0 border-r-0 border-b-sky-600 ') + 'p-2 border  font-bold text-xs w-full text-gray-800 flex items-center justify-between cursor-pointer'} onClick={()=>setShowTabsContent(6)}>Documents</div>
                        
                        }
                        {!caseDetails?.is_deleted && <div className={(showTabsContent === 3 ? 'bg-white border-t-sky-600 border-l-sky-600 border-r-sky-600 text-sky-600 border-b-0 ' : ' border-t-0 border-l-0 border-r-0 border-b-sky-600 ') + 'p-2  border font-bold text-xs w-full text-gray-800 flex items-center justify-between cursor-pointer'} onClick={()=>setShowTabsContent(3)}>Client Details</div>}
                        <div className={(showTabsContent === 4 ? 'bg-white border-t-sky-600 border-l-sky-600 border-r-sky-600 text-sky-600  border-b-0 ' : ' border-t-0 border-l-0 border-r-0 border-b-sky-600 ') + 'p-2 border  font-bold text-xs w-full text-gray-800 flex items-center justify-between cursor-pointer'} onClick={()=>setShowTabsContent(4)}>Attorney Info</div>
                        <div className={(showTabsContent === 5? 'bg-white border-t-sky-600 border-l-sky-600 border-r-sky-600 text-sky-600  border-b-0 ' : ' border-t-0 border-l-0 border-r-0 border-b-sky-600 ') + 'p-2 border  font-bold text-xs w-full text-gray-800 flex items-center justify-between cursor-pointer'} onClick={()=>setShowTabsContent(5)}>Reports</div>

                   </div>
                    
                    {showTabsContent === 1 ?
                    <div className='border-sky-600 border border-t-0  bg-white '>
                            <div className='flex w-full flex-col'>
                                <div className='flex w-full flex-col'>
                                    <div className=' ml-4 p-6 pt-0'>
                                        <div className='flex  items-left w-full justify-left mb-4 text-xs'>
                                            <div className= {(caseDetails.is_deleted ? "bg-gray-100 text-gray-600 ring-1 ring-gray-600 ring-offset-2" :contentStep === 6 ? 'bg-red-100 text-red-600 ring-1 ring-red-600 ring-offset-2' : (contentStep === 5 ? 'bg-yellow-100 text-yellow-600 ring-1 ring-yellow-600 ring-offset-2' : 'bg-green-100 text-green-600 ring-1 ring-green-600 ring-offset-2')) + ' p-1 rounded mt-10'}>
                                            Case Status: {caseDetails.is_deleted ? "Deleted" : contentStep === 5 ? "Pending Closing" : ( contentStep === 6 ? "Closed" : "Open")}
                                            </div>
                                        </div>
                                        <div className='mb-4 underline mt-4'>Case details</div>
                                        <RequiredInfo
                                        caseDetails={caseDetails}
                                        />
                                    </div>
                                </div>
                                
                                
                            </div>
                            
                    </div>
                    :
                    (showTabsContent === 2 ?
                        Object.entries(additionalFields).length 
                            ?
                            <div className='shadow-xl border p-8 w-full text-xs border-sky-600 border-t-0 border bg-white'>
                                    <AdditionalFields
                                        additionalFields={additionalFields}
                                    />
                                    
                            </div>
                            :
                            ""
                                
                        :
                        showTabsContent === 3 ?
                        <div className='w-full h-full border-sky-600 border-t-0 border bg-white'>
                                <ClientDetails hideBtn={true} data={caseDetails.owner}/>
                        </div>
                        :
                        (showTabsContent === 4 ?
                        <div className='w-full h-full border-sky-600 border-t-0 border bg-white'>
                           <CaseProfDetails userCaseDets={caseDetails.userCase}/>
                    </div>
                    :
                        (showTabsContent === 5 ?
                        <div className='bg-white  pb-10 border-sky-600 border-t-0 border bg-white'>
                            {reportedData.length !== 0  ?
                            <div className='w-full h-full px-40 text-xs mt-10  bg-white '>
                            <table className=' w-full h-full'>
                                <thead className='border-b-1 bg-sky-100 border mb-2'>
                                    <th className='text-left  text-sky-600 p-2 mb-2'>Name</th>
                                    <th className='text-left p-2 mb-2 text-sky-600 '>Email</th>
                                    <th className='text-left p-2 mb-2 text-sky-600 '>Reason</th>
                                    <th className='text-left p-2 mb-2 text-sky-600 '>Timestamp</th>

                                </thead>
                                <tbody>
                                    {reportedData?.map((rep) => {
                                        return <tr className='p-2'>
                                            <td className='p-2 border'>{rep?.userId?.firstName} {rep?.userId?.lastName}</td>
                                            <td className='p-2 border'>{rep?.userId?.email}</td>
                                            <td className='p-2 border'>{rep?.reported?.reason ? rep?.reported?.reason : "--"}</td>
                                            <td className='p-2 border'>{moment(rep?.updated_at).format("MM-DD-YYYY")}</td>
                                        </tr>
                                    })}                                        
                                </tbody>
                            </table>
                            </div>
                            :
                            <div className='flex justify-center text-xs mt-10'>No reports were made on this case or client</div>
                            }
                        </div>  
                        :
                        
                        <div className='flex flex-col'>
                                    
                        <div className='p-4 border-sky-600 border-t-0 border bg-white'>
                            
                            <DocumentsSection
                                caseDetails={caseDetails}
                                name = "supportingDocuments"
                                
                                />
                            <DocumentsSection
                                caseDetails={caseDetails}
                                name = "videoDocument"
                                />
                            </div>
                        </div>)      
                    ))
                    }
                </div>
              
                {/* <div className='w-full'>
                     <Stepper
                     currentStep={currentStep} 
                     setContentStep={setContentStep} 
                     contentStep={contentStep} 
                     caseDetails={caseDetails}
                     />
                     <StepperContent contentStep={contentStep} 
                        caseDetails={caseDetails}
                        setUpdateComp = {setUpdateComp}
                     />
                </div> */}
                <div className='flex   mt-10 w-full'>
                        <div className='flex justify-between w-full px-10'>
                                {contentStep === 5 &&
                                 <div 
                                onClick={() => onCloseCase()}
                                className='rounded mr-2 mb-1 text-white bg-sky-700 px-4 p-2 w-max flex items-end cursor-pointer'>
                                    Close case
                                </div>
                                }
                                {
                                    contentStep === 6 && 
                                
                                <div 
                                onClick={() => setShowModal(true)}
                                className='rounded mr-2 mb-1 text-white bg-red-700 px-4 p-2 w-max flex items-end cursor-pointer'>
                                    Delete case
                                </div>
                                }
                            </div>
                </div>
            </div>
        </div>
        :
        <></>
    }
    </>
       
  )
}

export default AdminCompleteCaseDetails